module.exports = __webpack_public_path__ + "media/images/admin/checkbox-inactive-d3340a8977f9555af44dea5a40dcb4cb.svg";